import React from "react";
import "./Header.css";
import { motion } from "framer-motion";

const Header = () => {
  return (
    
    <div className=" header d-flex align-items-center">
      
      <div class="text-center container tittle">
        <h5>Hi, I'm sunny</h5>
        <h1>Building web applications,SPA, and more experience</h1>
        <p style={{ color: 'whitesmoke'}}>
          Im a professional web developer, I have good experienced in SPA
          applications.
          <br />I love to eat new technologies so always active to Learn new
          things and touch on all web tech.
        </p>
        <motion.button
          whileHover={{ scale: 1.1 }}
          type="button"
          class="btn btn-dark mt-5"
        >
          Contact with Me
        </motion.button>
      </div>
    </div>
  );
};

export default Header;
